<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        md="6"
        sm="12"
      >
        <b-card-actions
          title="Introducción"
          action-collapse
        >
          <b-card-text><h2>Bienvenido de nuevo!</h2></b-card-text>
          <b-card-text>
            <p>Si no estás seguro de cómo comenzar, echa un vistazo a las notificaciones mostradas en la parte superior y a los modulos de aspirantes y solicitudes.</p>
          </b-card-text>
          <b-card-text>
            <p><span>Click en </span>
              <feather-icon icon="RotateCwIcon" />
              <span> icono para ver el contenido de la tarjeta actualizado.</span></p>
          </b-card-text>
          <b-card-footer class="pt-1 pb-0">
            <small class="text-muted"> {{ new Date() }}</small>
          </b-card-footer>
        </b-card-actions>
      </b-col>
      <b-col
        md="6"
        sm="12"
      >
        <reports />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        class="mb-2"
      >
        <b-card
          class="report-card"
          no-body
        >
          <b-row no-gutters>

            <!-- Lado izquierdo -->
            <b-col
              cols="12"
              md="8"
            >
              <div class="report-content">

                <div class="d-flex align-items-start">

                  <!-- Icono -->
                  <div class="report-icon bg-light-primary">
                    <feather-icon
                      icon="BarChart2Icon"
                      size="28"
                    />
                  </div>

                  <div class="ml-1">
                    <h3 class="mb-25">
                      Reportes estadísticos
                    </h3>

                    <p class="text-muted mb-0">
                      Consulta y analiza la información académica,
                      económica y de transacciones del periodo seleccionado.
                    </p>
                  </div>

                </div>

                <!-- Categorías -->
                <div class="report-categories mt-2">

                  <div class="report-category">
                    <div class="category-icon bg-light-success">
                      <feather-icon
                        icon="UsersIcon"
                        size="16"
                      />
                    </div>

                    <div>
                      <span class="d-block font-weight-bolder">
                        Académico
                      </span>

                      <small class="text-muted">
                        Aspirantes y registros
                      </small>
                    </div>
                  </div>

                  <div class="report-category">
                    <div class="category-icon bg-light-warning">
                      <feather-icon
                        icon="DollarSignIcon"
                        size="16"
                      />
                    </div>

                    <div>
                      <span class="d-block font-weight-bolder">
                        Económico
                      </span>

                      <small class="text-muted">
                        Órdenes y recaudación
                      </small>
                    </div>
                  </div>

                  <div class="report-category">
                    <div class="category-icon bg-light-info">
                      <feather-icon
                        icon="CreditCardIcon"
                        size="16"
                      />
                    </div>

                    <div>
                      <span class="d-block font-weight-bolder">
                        Transacciones
                      </span>

                      <small class="text-muted">
                        Pagos y facturación
                      </small>
                    </div>
                  </div>

                </div>

              </div>
            </b-col>

            <!-- Lado derecho -->
            <b-col
              cols="12"
              md="4"
              class="report-action"
            >
              <div class="text-center">

                <div class="action-icon">
                  <feather-icon
                    icon="TrendingUpIcon"
                    size="32"
                  />
                </div>

                <h5 class="mt-1 mb-50">
                  Consulta los reportes
                </h5>

                <p class="text-muted small mb-1">
                  Selecciona un plan y periodo para comenzar.
                </p>

                <b-button
                  variant="primary"
                  class="mt-50"
                  @click="goToReports"
                >
                  <feather-icon
                    icon="BarChart2Icon"
                    class="mr-50"
                  />
                  Ver estadísticas
                </b-button>

              </div>
            </b-col>

          </b-row>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        class="mt-2"
      >
        <team-support />
      </b-col>
    </b-row>

  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BCardText,
  BCardFooter,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Reports from './components/dashboard/Reports.vue'
import teamSupport from './components/dashboard/TeamCICL.vue'

/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    Reports,
    BCardActions,
    BCardText,
    BCardFooter,
    teamSupport,
  },
  setup(_, { root }) {
    const goToReports = () => {
      root.$router.push({
        name: 'servicio-escolar-analitica',
      })
    }

    return {
      goToReports,
    }
  },
}
</script>
<style scoped>
.report-card {
  border: 0;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

/* Contenido principal */
.report-content {
  padding: 28px;
}

/* Icono principal */
.report-icon {
  width: 58px;
  height: 58px;
  min-width: 58px;

  border-radius: 12px;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* Categorías */
.report-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.report-category {
  display: flex;
  align-items: center;

  padding: 10px 14px;

  border: 1px solid #ebe9f1;
  border-radius: 8px;

  min-width: 180px;
}

.category-icon {
  width: 34px;
  height: 34px;
  min-width: 34px;

  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 10px;
}

/* Acción */
.report-action {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 25px;

  background: #f8f8f8;
  border-left: 1px solid #ebe9f1;
}

.action-icon {
  width: 64px;
  height: 64px;

  margin: 0 auto;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  color: #7367f0;

  box-shadow: 0 4px 14px rgba(34, 41, 47, 0.08);
}

@media (max-width: 767px) {
  .report-action {
    border-left: 0;
    border-top: 1px solid #ebe9f1;
  }

  .report-category {
    width: 100%;
  }
}
</style>
